// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"11dbc53f","294":"3aae37ac"}[chunkId] + ".css";
};